<menu>
    <div *transloco="let t" class="text-[#F28F17] md:w-screen h-[150px] px-2.5 md:px-10 lg:max-w-[1080px] mx-auto flex items-center place-content-between">
        <img class="h-[80px] hover:h-[90px] cursor-pointer transition-all" src="./assets/logo.png"
            (click)="goTo(t('routes.home.path'))">
        <div class="flex gap-5 items-center"><std-click-outside (clickOutside)="showLang = false"> <std-tooltip position="left-bottom"
                    classTooltip="!w-fit bg-white shadow-xl h-[40px] border-[1px] border-black" [show]="showLang">
                    <div class="flex gap-5 px-2 items-center" tooltip>
                        <div content class="cursor-pointer text-[22px] hover:!text-[24px] transition-all" (click)="changeLang('it')">🇮🇹
                        </div>
                        <div class="cursor-pointer text-[22px] hover:!text-[24px] transition-all" (click)="changeLang('en')">🇺🇸</div>
                        <div class="cursor-pointer text-[22px] hover:!text-[24px] transition-all" (click)="changeLang('de')">🇩🇪</div>
                        <div class="cursor-pointer text-[22px] hover:!text-[24px] transition-all" (click)="changeLang('es')">🇪🇸</div>
                        <div class="cursor-pointer text-[22px] hover:!text-[24px] transition-all" (click)="changeLang('fr')">🇫🇷</div>
                    </div>
                    <div content class="cursor-pointer select-none text-[28px] hover:!text-[32px] transition-all"
                        (click)="showLang = true">
                        @if(currentLangIcon == 0){🇮🇹}
                        @if(currentLangIcon == 1){🇺🇸}
                        @if(currentLangIcon == 2){🇩🇪}
                        @if(currentLangIcon == 3){🇪🇸}
                        @if(currentLangIcon == 4){🇫🇷}
                    </div>
                </std-tooltip></std-click-outside>
            @if(user?.role == 1){<div class="hover:underline cursor-pointer font-semibold transition-all text-[24px] hover:text-[28px]"
                (click)="goTo('live')">{{t('routes.live.menu')}}</div>}
               @if(!user?.role ){ 
                <img src="./assets/login.svg" (click)="goTo('login')" class="h-[32px] cursor-pointer transition-all hover:!h-[40px]">
                <!-- <div class="hover:underline cursor-pointer font-semibold transition-all text-[24px] hover:text-[28px]"
                (click)="goTo('login')">{{t('auth.login')}}</div> -->
                }
                @if(user?.role == 4){ <div class="hover:underline cursor-pointer font-semibold transition-all text-[24px] hover:text-[28px]"
                (click)="goTo(t('routes.yourQuizs.path'))">{{t('routes.yourQuizs.menu')}}</div>}
        @if(user){
            <img src="./assets/logout.svg" (click)="logout()" class="h-[32px] cursor-pointer transition-all hover:!h-[40px]">}
        </div>
    </div>
</menu>